import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { HttpService } from "../../../../../http.service";
import { UtilsService } from "../../../../shared/services/utils.service";
import { AuthService } from "../../../../shared/services/auth.service";
import { apiURL, EnvConfig } from "../../../../../env-config";

let self: TaskShareService;

@Injectable()
export class TaskShareService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService
  ) {
    self = this;
  }

  downloadQuote(id?: string){
    let query = { "company": this._AuthService.companyId() }
    let queryParams: string = '?' + this._utilsService.toQueryString(query);
    this._http.get(`${apiURL(EnvConfig.API_QUOTES)}/${id}/generatePdf${queryParams}`, { responseType: "arraybuffer" }).subscribe(file => {
        this._utilsService.blobToFile(file, "application/pdf", 'quote' + '.pdf');
    });
  }

  downloadBillingDocument(id?: string){
    let query = { "company": this._AuthService.companyId() }
    let queryParams: string = '?' + this._utilsService.toQueryString(query);
    this._http.get(`${apiURL(EnvConfig.API_BILLING_DOCUMENTS)}/${id}/generatePdf${queryParams}`, { responseType: "arraybuffer" }).subscribe(file => {
        this._utilsService.blobToFile(file, "application/pdf", 'invoice' + '.pdf');
    });
  }


  sendEmailQuote(id?: string, data?: any): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_QUOTES)}/${id}/sendEmail`,data);
  }

  sendEmailBillingDocument(id?: string, data?: any): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_BILLING_DOCUMENTS)}/${id}/sendEmail`,data);
  }

}